import * as colors from '@giphy/colors'
import { TitleLarge, TitleSmall } from 'shared/components/text-elements'
import styled from 'styled-components'
import Accent from './accent'
import { Android, Apple, Oculus, ProductLink, Vive } from './app-links'
import Device from './device'
import MoreInfo from './more-info'
import Screenshot from './screenshot'
import Title from './title'

const Container = styled.div`
    background: ${colors.giphyDarkestGrey};
    color: ${colors.giphyWhite};
    overflow: hidden;
    position: relative;
    text-align: left;
`

const Content = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: ${(props) => (props.right ? 'row-reverse' : 'row')};
    height: 580px;
    justify-content: flex-end;
    padding: 60px 0 70px;
    position: relative;
    width: 100%;
`

const Info = styled.div`
    box-sizing: border-box;
    line-height: 1.4;
    margin-right: ${(props) => (props.right ? 'auto' : 0)};
    padding: 0 50px;
    width: 100%;
`

const Subtitle = styled(TitleSmall)`
    color: rgba(255, 255, 255, 0.6);
`

const LearnMore = styled.a`
    color: ${colors.giphyWhite};
    font-weight: bold;
    text-transform: uppercase;

    &:hover {
        color: ${colors.giphyWhite};
    }

    i {
        display: inline-block;
        font-size: 12px;
        line-height: 12px;
        margin-left: 2px;
        vertical-align: middle;
    }
`

const Links = styled.div`
    clear: both;
    padding-top: 30px;
`

const VideoEmbed = styled.div`
    padding: 40px 50px;
    text-align: center;
`

const Video = styled.div`
    clear: both;
    display: inline-block;
    margin: 0 auto;
    padding: 20px 0;
`

const AppDetail = ({
    background_color: backgroundColor,
    accent_color: accentColor,
    icon_url: iconUrl,
    screenshot_url: screenshotUrl,
    product_url: productUrl,
    android_url: androidUrl,
    ios_url: iOSUrl,
    oculus_url: oculusUrl,
    vive_url: viveUrl,
    is_desktop: isDesktop,
    info_items: infoItems,
    video_embed: videoEmbed,
    index = 0,
    slug = '',
    description = '',
    subheading,
    name,
    isDetail,
}) => {
    const isRight = index % 2 === 1
    return (
        <Container style={{ backgroundColor }}>
            <Accent accent={accentColor} right={isRight} />
            <Content right={isRight}>
                <Device desktop={isDesktop} right={isRight}>
                    <Screenshot image={screenshotUrl} />
                </Device>
                <Info>
                    {name && <Title icon={iconUrl}>{name}</Title>}
                    {subheading && <Subtitle>{subheading}</Subtitle>}
                    <p>{description}</p>
                    {!isDetail && (
                        <LearnMore href={`/apps/${slug}`}>
                            Learn More <i className="ss-navigateright" />
                        </LearnMore>
                    )}
                    <Links>
                        {productUrl && (
                            <ProductLink href={productUrl} target="_blank">
                                Check it out
                            </ProductLink>
                        )}
                        {iOSUrl && <Apple href={iOSUrl} target="_blank" />}
                        {androidUrl && <Android href={androidUrl} target="_blank" />}
                        {viveUrl && <Vive href={viveUrl} target="_blank" />}
                        {oculusUrl && <Oculus href={oculusUrl} target="_blank" />}
                    </Links>
                </Info>
            </Content>
            {isDetail && infoItems && <MoreInfo dangerouslySetInnerHTML={{ __html: infoItems }} />}
            {isDetail && videoEmbed && (
                <VideoEmbed>
                    <Subtitle>Still not impressed?</Subtitle>
                    <TitleLarge>Watch the Video</TitleLarge>
                    <Video dangerouslySetInnerHTML={{ __html: videoEmbed }} />
                </VideoEmbed>
            )}
        </Container>
    )
}

export default AppDetail
